
export default {
  // Navigation
  nav_home: 'Inicio',
  nav_services: 'Conocimiento',
  nav_differentials: 'Diferenciales',
  nav_about: 'Acerca',
  nav_contact: 'Resuelve Dudas',
  nav_login: 'Ingresar',
  nav_blog: 'Blog',
  nav_calculator: 'Calculadora',
  nav_resources: 'Recursos',
  nav_cta: 'Explorar Contenido',

  // Blog
  blog: {
    hero: {
      title: 'Conocimiento que Genera Valor',
      subtitle: 'Insights, guías prácticas y estrategias para inmigrantes y emprendedores que buscan excelencia fiscal y crecimiento sostenible en Estados Unidos.'
    },
    newsletter: {
      title: 'Recibe Contenido Exclusivo',
      description: 'Suscríbete a nuestro newsletter y recibe insights, consejos fiscales y actualizaciones sobre compliance directamente en tu email.',
      placeholder: 'Tu mejor email',
      button: 'Suscribirse'
    },
    featured_badge: 'Destacado',
    featured_articles: 'Artículos Destacados',
    all_articles: 'Todos los Artículos',
    articles_count: 'artículos',
    no_articles_found: 'Ningún artículo encontrado',
    search_placeholder: 'Buscar artículos...',
    author_team: 'Equipo Valora Core'
  },

  // Calculator
  calculator: {
    title: 'Calculadora Educativa de Escenarios Fiscales',
    disclaimer: 'Esta herramienta presenta simulaciones basadas en escenarios genéricos para fines educativos y no sustituye análisis profesional individualizado.',
    year_label: 'Año fiscal',
    year_tooltip: 'Elige el año fiscal. Las escalas y deducciones varían por año.',
    year_2025: '2025',
    year_2024: '2024',
    legal_notice_title: 'Base legal y avisos',
    legal_notice_text: 'IRC §1, §11, §63, §1401–§1402 (SE tax), §3101–§3111 (FICA), §199A (QBI). S‑Corp exige salario razonable para socio‑trabajador; distribuciones sin salario pueden ser reclasificadas con FICA retroactiva, multas e intereses.',
    form_title: 'Datos para Cálculo',
    entity_type_label: 'Tipo de Entidad',
    entity_type_tooltip: 'Cómo eres tributado: PF/LLC (autónomo), S‑Corp (exige salario razonable) o C‑Corp (impuesto en la empresa y posible impuesto en dividendos).',
    entity_pf: 'Persona Física / Autónomo',
    entity_llc: 'LLC (disregarded/partnership por defecto)',
    entity_scorp: 'S‑Corp',
    entity_ccorp: 'C‑Corp',
    filing_status_label: 'Estado de Declaración',
    filing_status_tooltip: 'Define las escalas del IRPF y el umbral de Medicare adicional según el estado.',
    filing_single: 'Soltero',
    filing_mfj: 'Casado Declarando Conjuntamente',
    filing_mfs: 'Casado Declarando Separadamente',
    filing_hoh: 'Jefe de Hogar',
    gross_income_label: 'Ingresos Brutos Anuales',
    gross_income_tooltip: 'Ingresos totales antes de gastos deducibles. Para PF: ingresos de autónomo. Para empresa: ingresos totales.',
    expenses_label: 'Gastos Deducibles',
    expenses_tooltip: 'Gastos relacionados con el negocio que reducen la renta gravable.',
    other_w2_label: 'Otros Ingresos W-2',
    other_w2_tooltip: 'Salario de empleo o otras fuentes W-2. Afecta límites de Seguridad Social.',
    reasonable_salary_label: 'Salario Razonable',
    reasonable_salary_tooltip: 'Para S-Corp y C-Corp: salario mínimo justo para socio-trabajador. IRS exige que sea "razonable" para la función.',
    payout_ratio_label: 'Proporción de Distribución',
    payout_ratio_tooltip: 'Porcentaje del beneficio después de impuestos corporativos distribuido como dividendos.',
    qualified_dividends_label: 'Dividendos Cualificados',
    qualified_dividends_tooltip: 'Dividendos cualificados tienen tributación preferencial (0%, 15% o 20%).',
    apply_qbi_label: 'Aplicar Deducción QBI',
    apply_qbi_tooltip: 'Sección 199A permite hasta 20% de deducción en ingresos de negocios cualificados.',
    results_title: 'Resultados',
    income_tax: 'Impuesto sobre la Renta',
    se_tax: 'Impuesto de Trabajo Autónomo',
    payroll_taxes: 'Impuestos de Nómina',
    corp_tax: 'Impuesto Corporativo',
    shareholder_div_tax: 'Impuesto s/ Dividendos',
    qbi_deduction: 'Deducción QBI',
    total_tax: 'Total de Impuestos',
    effective_rate: 'Tasa Efectiva',
    net_income: 'Ingresos Netos',
    waiting_calculation: 'Esperando datos para cálculo automático...',
    additional_note: 'S‑Corp exige salario razonable para socio-trabajador. LLC por defecto tributa como PF/partnership. C‑Corp tiene doble tributación (empresa y dividendos).'
  },

  // Resources
  resources: {
    items: {
      itin_guide: {
        title: 'Guía Completa ITIN 2024',
        description: 'Paso a paso detallado para obtener tu ITIN, documentos necesarios y plazos.'
      },
      llc_checklist: {
        title: 'Checklist Apertura de LLC',
        description: 'Lista completa de documentos y pasos para abrir tu LLC en EE.UU.'
      }
    }
  },

  // Hero section
  hero_badge: "Orlando, FL • Atención Nacional",
  hero_title: "Educación Fiscal para Inmigrantes en EE.UU.",
  hero_subtitle: "Contenido técnico, práctico y en português sobre impuestos, compliance y estructuras empresariales en Estados Unidos.",
  hero_description: "Valora Core opera, en esta fase, con enfoque exclusivo en educación técnica y claridad informacional.",
  hero_cta_primary: "Explorar Contenido",
  hero_cta_secondary: "Suscribirse al Newsletter",
  
  // Services section
  services_badge: "CONTENIDO EDUCATIVO",
  services_title: "Aprende Sobre Tributación Americana",
  services_subtitle: "Contenido didáctico para dominar impuestos, compliance y estructuras empresariales en Estados Unidos",
  services_read_more: "Leer contenido completo",
  
  service_tax_title: "Impuestos PF/PJ",
  service_tax_subtitle: "Aprende sobre declaración de impuestos PF/PJ en USA. Conoce formularios, plazos y estrategias.",
  service_tax_1: "Entiende el Form 1040 / 1040-NR",
  service_tax_2: "Conoce tributación de Partnership (1065)",
  service_tax_3: "Aprende sobre S-Corporation (1120-S)",
  service_tax_4: "Comprende C-Corporation (1120)",
  service_tax_5: "Cómo revisar declaraciones anteriores",
  service_tax_6: "Principios de planificación tributaria",
  service_tax_7: "Entender qué es QBI Deduction (IRC §199A)",
  
  service_company_title: "Apertura de Empresa",
  service_company_subtitle: "Comprende estructuras empresariales y aprende a tomar decisiones informadas sobre tu negocio.",
  service_company_1: "Diferencias entre LLC, C-Corp y S-Corp",
  service_company_2: "Entiende Operating Agreements",
  service_company_3: "Conoce EIN y BOI Report (FinCEN)",
  service_company_4: "Aprende clasificación fiscal",
  service_company_5: "Comprende planificación tributaria",
  service_company_6: "Principios de cumplimiento empresarial",
  
  service_itin_title: "ITIN",
  service_itin_subtitle: "Entiende el proceso de obtención del ITIN y sus requisitos legales en EE.UU.",
  service_itin_1: "Comprende el proceso ITIN completo",
  service_itin_2: "Aprende sobre renovación de ITIN",
  service_itin_3: "Conoce el papel de los CAA",
  service_itin_4: "Entiende plazos y seguimiento",
  service_itin_5: "Documentación necesaria y requisitos",
  service_itin_6: "Certified Acceptance Agent (CAA)",
  
  service_compliance_title: "Compliance",
  service_compliance_subtitle: "Aprende sobre obligaciones legales y mantén tu empresa siempre en cumplimiento.",
  service_compliance_1: "Entiende reportes anuales estatales",
  service_compliance_2: "Comprende BOI Report (FinCEN)",
  service_compliance_3: "Aprende sobre calendario de obligaciones",
  service_compliance_4: "Principios de monitoreo continuo",
  service_compliance_5: "Conoce cumplimiento IRS y FinCEN",
  service_compliance_6: "Cómo prevenir multas y penalidades",
  
  service_accounting_title: "Gestión Financiera Empresarial",
  service_accounting_subtitle: "Aprende sobre organización contable y control financiero para pequeñas empresas.",
  service_accounting_1: "Principios de conciliación bancaria",
  service_accounting_2: "Categorización de transacciones",
  service_accounting_3: "Entendiendo reportes gerenciales",
  service_accounting_4: "Cómo crear calendario fiscal eficiente",
  service_accounting_5: "Técnicas de categorización fiscal",
  service_accounting_6: "Interpretación de reportes financieros",

  service_credits_title: "Créditos y Deducciones Fiscales (PF)",
  service_credits_subtitle: "Aprende a identificar créditos y deducciones permitidos por ley y entiende cómo impactan directamente el impuesto adeudado o el reembolso.",
  service_credits_1: "Diferencia entre deducciones, créditos no reembolsables y créditos reembolsables",
  service_credits_2: "EITC - Earned Income Tax Credit (funcionamiento y elegibilidad)",
  service_credits_3: "Child Tax Credit (CTC) y Additional Child Tax Credit",
  service_credits_4: "Credit for Other Dependents (conceptos y aplicación)",
  service_credits_5: "Deducciones estándar vs. itemized deductions (cuándo usar cada una)",
  service_credits_6: "Gastos médicos, educativos y de trabajo (cuando aplicable)",
  service_credits_7: "Principios de elegibilidad, límites de ingresos y errores comunes",
  service_credits_8: "Cómo evitar rechazos, auditorías y ajustes del IRS",

  lang_portuguese: "Português",
  lang_spanish: "Español",
  lang_english: "English",

  // Important Info section
  info_badge: "INFORMACIÓN IMPORTANTE",
  info_title: "Mantente informado sobre tus derechos y obligaciones",
  info_subtitle: "Información esencial para brasileños en EE.UU.",
  info_card_1_title: "¿Dejaste Brasil? Haz tu Salida Fiscal y evita problemas con la Receita Federal.",
  info_card_1_description: "Si te mudaste a EE.UU. y aún declaras impuestos en Brasil, podrías estar pagando más de lo debido. Aprende cómo regularizar tu situación y evitar multas.",
  info_card_2_title: "Si eres estudiante en EE.UU., ¡el Form 8843 es obligatorio!",
  info_card_2_description: "Incluso sin ingresos, los estudiantes F-1, F-2, J-1 y M-1 deben enviar el Form 8843 al IRS cada año. Ignorar este documento puede afectar tu estatus futuro.",
  info_card_3_title: "¿Necesitas declarar impuestos pero no tienes SSN? Necesitas un ITIN.",
  info_card_3_description: "El ITIN es el número fiscal del IRS para quienes no tienen Social Security. Con él, puedes declarar impuestos, abrir cuentas bancarias y construir historial financiero en EE.UU.",

  // Client Portal
  client_dashboard: "Resumen",
  client_documents: "Documentos",
  client_messages: "Mensajes",
  client_invoices: "Facturas",
  client_welcome: "Bienvenido de nuevo",
  client_services_status: "Estado de los Servicios",
  client_pending_documents: "Documentos Pendientes",
  client_upcoming_deadlines: "Próximos Plazos",
  client_recent_activity: "Actividad Reciente",
  client_upload_document: "Subir Documento",
  client_view_all: "Ver Todos",
  client_send_message: "Enviar Mensaje",
  client_new_message: "Nuevo Mensaje",
  client_pay_now: "Pagar Ahora",
  client_download: "Descargar",
  client_status_in_progress: "En Progreso",
  client_status_completed: "Completado",
  client_status_pending: "Pendiente",
  client_logout: 'Cerrar sesión',
  client_collapse_menu: 'Contraer menú',
  client_expand_menu: 'Expandir menú',

  // About section
  about_badge: "POR QUÉ EDUCACIÓN",
  about_title: "¿Por qué priorizamos la educación?",
  about_intro: "Valora Core ofrece educación técnica y contenido especializado sobre impuestos y cumplimiento para inmigrantes, con sede en Orlando (FL) y actuación en todo Estados Unidos.",
  about_description_1: "Valora Core cree que las decisiones fiscales conscientes dependen de la comprensión técnica. Por eso, elegimos consolidar nuestra autoridad a través de la educación antes de ampliar nuestra actuación operacional, estableciendo una base sólida de confianza.",
  about_description_2: "Nuestro compromiso es reducir la asimetría de información fiscal y regulatoria enfrentada por inmigrantes en EE.UU., proporcionando contenido preciso, analítico y pedagógico en portugués.",
  about_mission_intro: "Principio rector:",
  about_mission: "La educación precede a la operación. La autoridad precede a la escala.",
  about_certification_title: "Especialista en Contabilidad para Inmigrantes",
  about_certification_desc: "Certificado y registrado para atender clientes en todos los estados americanos",
  about_languages_title: "3 Idiomas",
  about_languages_list: "PT • ES • EN",
  
  // Stats
  about_stat_clients_number: "500+",
  about_stat_clients_label: "Clientes Atendidos",
  about_stat_satisfaction_number: "98%",
  about_stat_satisfaction_label: "Satisfacción",
  about_stat_experience_number: "5+",
  about_stat_experience_label: "Años de Experiencia",
  about_stat_support_number: "24/7",
  about_stat_support_label: "Soporte",
  
  // Client types
  about_clients_title: "Nuestros Clientes",
  about_clients_subtitle: "Atendemos diferentes perfiles con soluciones personalizadas para cada necesidad",
  
  about_client_immigrants_title: "Inmigrantes",
  about_client_immigrants_subtitle: "Tranquilidad fiscal para quienes empezaron de nuevo en EE.UU.",
  about_client_immigrants_description: "Soporte completo en portugués y español para regularización fiscal y crecimiento.",
  
  about_client_freelancers_title: "Autónomos",
  about_client_freelancers_subtitle: "Simplificamos tu contabilidad para que te enfoques en crecer.",
  about_client_freelancers_description: "Declaraciones, ITIN, planificación tributaria y estructuración empresarial personalizada.",
  
  about_client_small_business_title: "Pequeños Negocios",
  about_client_small_business_subtitle: "Desde la apertura hasta la expansión, cuidamos toda la estructura.",
  about_client_small_business_description: "LLC, S-Corp, C-Corp, compliance, contabilidad mensual y consultoría estratégica.",
  
  about_client_entrepreneurs_title: "Nuevos Emprendedores",
  about_client_entrepreneurs_subtitle: "Abre tu empresa de la manera correcta, sin complicaciones.",
  about_client_entrepreneurs_description: "Orientación completa desde la estructuración hasta el primer año de operación.",

  // Footer section
  footer_description: "Educación fiscal y tributaria especializada para brasileños en EE.UU.",
  footer_services_title: "Recursos Educativos",
  footer_company_title: "Empresa",
  footer_contact_title: "Resuelve Dudas",
  footer_about_us: "Acerca de Nosotros",
  footer_differentials: "Diferenciales",
  footer_contact: "Contacto",
  footer_blog: "Blog",
  footer_location: "Orlando, FL\nEstados Unidos",
  footer_copyright: `© ${new Date().getFullYear()} Valora Core. Todos los derechos reservados.`,
  footer_privacy_policy: "Política de Privacidad",
  footer_terms_of_use: "Términos de Uso",
  footer_powered_by: "Powered by Conexdev Solutions",

  // Differentials section
  differentials_badge: "NUESTRO ENFOQUE",
  differentials_title: "¿Por qué aprender con Valora Core?",
  differentials_subtitle: "Más que contenido tributario, enseñamos estrategias prácticas para que inmigrantes dominen sus finanzas en EE.UU.",
  
  differential_compliance_title: "Educación Preventiva",
  differential_compliance_description: "Enseñamos a hacerlo bien desde el primer día.",
  differential_compliance_details: "Nuestro enfoque es enseñar cómo prevenir problemas fiscales antes de que ocurran, capacitándote para navegar con confianza en el sistema americano.",
  
  differential_communication_title: "Didáctica y Claridad",
  differential_communication_description: "Enseñamos en tu idioma — literalmente.",
  differential_communication_details: "Explicamos cada concepto con claridad, sin términos complicados, para que aprendas y domines el proceso.",
  
  differential_specialization_title: "Especialización en Inmigración",
  differential_specialization_description: "Entendemos los desafíos de empezar desde cero.",
  differential_specialization_details: "Enseñamos sobre toda la estructura fiscal y contable americana, considerando documentación, plazos y desafíos específicos de quienes viven fuera de Brasil.",
  
  differential_digital_title: "Aprendizaje Práctico",
  differential_digital_description: "Contenido accesible desde cualquier lugar de EE.UU.",
  differential_digital_details: "Combinación de contenido digital y ejemplos prácticos, de la manera que los brasileños necesitan para dominar la tributación americana.",

  // FAQ section
  faq_title: "Preguntas Frecuentes",
  faq_subtitle: "Aclara tus dudas sobre tributación americana. ¿No encontraste la respuesta? ¡Envía tu pregunta!",
  faq_cta_title: "¿Necesitas más información?",
  faq_cta_subtitle: "¡Explora nuestro contenido educativo o envía tu pregunta específica sobre tributación!",
  faq_cta_speak: "Explorar Contenido",
  faq_cta_email: "Enviar Email",

  // FAQ ITIN
  faq_itin_category: "ITIN",
  faq_itin_q1: "¿Qué es el ITIN y quién lo necesita?",
  faq_itin_a1: "ITIN (Individual Taxpayer Identification Number) es un número de identificación tributaria emitido por el IRS para personas que necesitan presentar impuestos en USA pero no son elegibles para SSN. Es necesario para no residentes con ingresos en USA, dependientes de ciudadanos/residentes y cónyuges de americanos.",
  faq_itin_q2: "¿Cuánto tiempo toma obtener el ITIN?",
  faq_itin_a2: "El proceso completo toma entre 7 a 11 semanas después de que el IRS reciba tu solicitud. Con Valora Core, preparamos toda la documentación en 3-5 días hábiles y acompañamos todo el proceso hasta la aprobación.",
  faq_itin_q3: "¿Qué documentos se necesitan?",
  faq_itin_a3: "Necesitarás: pasaporte válido (original o copia certificada), formulario W-7 completado, declaración de impuestos (si aplica) y documentos que comprueben la necesidad del ITIN. Nuestro equipo te guía en cada paso.",

  // FAQ Business Formation
  faq_business_category: "Formación de Empresas",
  faq_business_q1: "LLC o S-Corp: ¿cuál elegir?",
  faq_business_a1: "LLC es ideal para pequeños negocios y freelancers, ofreciendo flexibilidad y protección personal. S-Corp es mejor para empresas con lucro superior a $60k/año, permitiendo ahorros en impuestos sobre nómina. Hacemos análisis gratuito de tu caso para recomendar la mejor estructura.",
  faq_business_q2: "¿Cuánto cuesta abrir una LLC?",
  faq_business_a2: "Los costos varían por estado. En Florida, por ejemplo, la tasa estatal es $125 + nuestras tarifas de $499 (paquete completo incluyendo EIN, Operating Agreement y consultoría). Ofrecemos paquetes personalizados para cada necesidad.",
  faq_business_q3: "¿Puedo abrir una empresa sin SSN?",
  faq_business_a3: "¡Sí! Puedes abrir LLC/S-Corp usando ITIN o incluso sin número tributario inicialmente. Ayudamos a no residentes y extranjeros a estructurar empresas en USA de forma 100% legal y conforme.",

  // FAQ additional categories
  faq_taxes_category: "Impuestos",
  faq_taxes_q1: "¿Cuáles son las fechas límite fiscales importantes?",
  faq_taxes_a1: "Persona Física (1040): 15 de abril. LLC/Partnership (1065): 15 de marzo. S-Corp (1120-S): 15 de marzo. C-Corp (1120): 15 de abril. Impuestos estimados trimestrales: 15/abr, 15/jun, 15/sep, 15/ene. Enviamos recordatorios automáticos para todas las fechas.",
  faq_taxes_q2: "¿Qué es el Reporte BOI (FinCEN)?",
  faq_taxes_a2: "BOI (Beneficial Ownership Information) es un reporte obligatorio desde 2024 para la mayoría de empresas en USA, informando quiénes son los propietarios reales. Empresas creadas antes de 2024 tienen hasta 31/dic/2024 para reportar. Multa por incumplimiento: hasta $10,000. Hacemos todo el proceso por ti.",
  faq_taxes_q3: "¿Puedo deducir gastos de oficina en casa?",
  faq_taxes_a3: "¡Sí! Puedes deducir un porcentaje de alquiler, internet, servicios y mantenimiento proporcional al espacio usado exclusivamente para trabajo. También son deducibles: equipos, software, viajes de negocios, y mucho más. Maximizamos tus deducciones legalmente.",

  faq_services_category: "Servicios",
  faq_services_q1: "¿Atienden en todo USA?",
  faq_services_a1: "¡Sí! Nuestra oficina física está en Orlando, FL, pero atendemos clientes en los 50 estados a través de consultas, email y teléfono. Ofrecemos servicios completos con la misma calidad del servicio presencial.",
  faq_services_q2: "¿Cómo funciona la primera consulta gratuita?",
  faq_services_a2: "Agenda una videollamada de 30 minutos con nuestros especialistas. Entenderemos tu situación, responderemos tus dudas y presentaremos un plan personalizado sin compromiso. Atendemos en Português y Español.",
  faq_services_q3: "¿Qué formas de pago aceptan?",
  faq_services_a3: "Aceptamos tarjetas de crédito/débito (Visa, Mastercard, Amex), transferencias bancarias (ACH), Zelle, PayPal y pagos en cuotas hasta 3x sin intereses para servicios superiores a $500. Emitimos recibos y facturas para todas las transacciones.",

  // CTA section
  cta_title: "Transforma Conocimiento en Seguridad Fiscal",
  cta_subtitle: "Aprender es el primer paso. Dominar la tributación americana es el siguiente.",
  cta_description: "En Valora Core, cada concepto tributario se transforma en confianza para tomar decisiones informadas.",
  cta_feature_1: "Contenido práctico y aplicado",
  cta_feature_2: "Aprendizaje personalizado",
  cta_feature_3: "Conocimiento sostenible",
  cta_button: "Explorar Artículos",
  cta_footer: "Contenido gratuito y accesible • Sin compromiso • Disponible nacionalmente",

  // WhatsApp component
  whatsapp_number: "16897774321",
  whatsapp_comment: "Número de WhatsApp de Valora Core (reemplazar con número real)",
  whatsapp_business_title: "💼 Abrir Empresa en USA",
  whatsapp_business_message: "¡Hola! Me gustaría saber más sobre abrir una empresa en USA (LLC/S-Corp).",
  whatsapp_itin_title: "🆔 Solicitar ITIN",
  whatsapp_itin_message: "¡Hola! Necesito ayuda para obtener mi ITIN (Individual Taxpayer Identification Number).",
  whatsapp_taxes_title: "📊 Declaración de Impuestos",
  whatsapp_taxes_message: "¡Hola! Me gustaría información sobre declaración de impuestos en USA.",
  whatsapp_boi_title: "📋 Reporte BOI",
  whatsapp_boi_message: "¡Hola! Necesito ayuda con el Reporte BOI (Beneficial Ownership Information).",
  whatsapp_other_title: "💬 Otro Asunto",
  whatsapp_other_message: "¡Hola! Me gustaría explorar el contenido educativo de Valora Core.",
  whatsapp_button_title: "Resuelve Dudas",
  whatsapp_button_subtitle: "Elige un asunto:",
  whatsapp_close: "Cerrar",

  // Newsletter
  newsletter_title: "Newsletter Educativo",
  newsletter_description: "Recibe actualizaciones semanales sobre cumplimiento, impuestos y planificación tributaria para inmigrantes",
  newsletter_placeholder: "Tu mejor correo electrónico",
  newsletter_button: "Suscribirse",
  newsletter_disclaimer: "Contenido gratuito. Sin spam. Cancela cuando quieras.",

  // Blog categories
  categories: {
    all: 'Todos',
    impostos: 'Impuestos',
    abertura_empresa: 'Apertura de Empresa',
    compliance: 'Cumplimiento',
    planejamento_tributario: 'Planificación Tributaria',
    gestao_financiera: 'Gestión Financiera',
    empreendedorismo: 'Emprendimiento'
  },

  // Blog post interface
  blog_post: {
    you_will_learn: 'En este artículo aprenderás:',
    fundamental_concepts: 'Conceptos fundamentales sobre el tema',
    practical_steps: 'Paso a paso práctico y aplicable',
    expert_tips: 'Consejos de expertos de Valora Core',
    avoid_errors: 'Cómo evitar errores comunes',
    why_important: '¿Por Qué Esto es Importante?',
    importance_description: 'Para inmigrantes y emprendedores en Estados Unidos, comprender las sutilezas fiscales y regulatorias es fundamental para el éxito y crecimiento sostenible del negocio. La falta de conocimiento puede resultar en penalidades, multas y oportunidades perdidas de ahorro fiscal.',
    valora_tip: 'Consejo de Valora Core',
    tip_description: 'Siempre mantén tu documentación organizada y actualizada. Esto facilita no solo el cumplimiento de las obligaciones fiscales, sino que también permite identificar oportunidades de optimización tributaria durante el año.',
    main_points: 'Principales Puntos de Atención',
    points_description: 'Al tratar con asuntos fiscales y contables en Estados Unidos, es esencial prestar atención a diversos aspectos que pueden impactar significativamente tu situación tributaria:',
    deadlines: 'Plazos establecidos por el IRS y agencias estatales',
    documentation: 'Documentación requerida y requisitos específicos',
    deductions: 'Oportunidades de deducciones y créditos fiscales',
    compliance_regulations: 'Cumplimiento y adhesión a regulaciones vigentes',
    how_we_help: 'Cómo Valora Core Puede Ayudar',
    help_description: 'Nuestro equipo de expertos está preparado para ofrecer soporte completo en todas las etapas del proceso. Con atención en Portugués y Español, garantizamos que comprendas totalmente cada aspecto de tu situación fiscal y tomes decisiones informadas para el crecimiento de tu negocio.',
    need_help: '¿Tienes una pregunta técnica sobre este tema?',
    schedule_consultation: 'Deja tu comentario o suscríbete a nuestro newsletter para recibir actualizaciones semanales de compliance.',
    contact_specialist: 'Suscribirse al Newsletter',
    conclusion: 'Conclusión',
    conclusion_description: 'Comprender y gestionar adecuadamente tus obligaciones fiscales es fundamental para el éxito de tu negocio en Estados Unidos. Con soporte adecuado y conocimiento especializado, puedes transformar el cumplimiento en ventaja competitiva y enfocarte en lo que realmente importa: el crecimiento sostenible de tu empresa.',
    tags: 'ETIQUETAS',
    share: 'COMPARTIR',
    related_articles: 'Artículos Relacionados'
  },

  // Consentimiento de Cookies
  cookie_title: 'Utilizamos Cookies',
  cookie_description: 'Utilizamos cookies para mejorar tu experiencia de navegación, proporcionar contenido personalizado, analizar tráfico y mejorar nuestros servicios. Algunas cookies son esenciales para el funcionamiento adecuado del sitio.',
  cookie_settings: 'Configuración de Cookies',
  cookie_accept_all: 'Aceptar Todas',
  cookie_reject: 'Rechazar Opcionales',
  cookie_reject_all: 'Rechazar Todas',
  cookie_save_preferences: 'Guardar Preferencias',
  cookie_settings_title: 'Preferencias de Cookies',
  cookie_settings_description: 'Utilizamos diferentes tipos de cookies para varios propósitos. Puedes personalizar tus preferencias a continuación. Ten en cuenta que deshabilitar algunas cookies puede afectar la funcionalidad del sitio.',
  cookie_always_active: 'Siempre Activo',
  
  cookie_necessary_title: 'Cookies Necesarias',
  cookie_necessary_description: 'Estas cookies son esenciales para el funcionamiento del sitio web y no se pueden deshabilitar. Generalmente se establecen en respuesta a acciones que realizas, como preferencias de idioma, inicio de sesión o envío de formularios.',
  
  cookie_analytics_title: 'Cookies de Análisis',
  cookie_analytics_description: 'Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web recopilando e informando información de forma anónima. Esto nos ayuda a mejorar la experiencia del usuario.',
  
  cookie_marketing_title: 'Cookies de Marketing',
  cookie_marketing_description: 'Estas cookies se utilizan para proporcionarte anuncios y comunicaciones de marketing relevantes. Pueden usarse para construir un perfil de tus intereses y mostrarte anuncios relevantes.',
  
  cookie_functional_title: 'Cookies Funcionales',
  cookie_functional_description: 'Estas cookies habilitan funcionalidades mejoradas y personalización, como videos y chats en vivo. Pueden ser establecidas por nosotros o por proveedores terceros.',

  // Política de Privacidad
  privacy_policy_title: 'Política de Privacidad',
  privacy_policy_last_updated: 'Última actualización',
  privacy_policy_introduction_title: 'Introducción',
  privacy_policy_introduction_text: 'Valora Core LLC ("nosotros", "nuestro" o "nos") es una empresa de contabilidad especializada en inmigrantes, con sede en Orlando, FL y operaciones en todo Estados Unidos. Estamos comprometidos en proteger tu privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos tu información cuando visitas nuestro sitio web y usas nuestros servicios de contabilidad e impuestos.',
  privacy_policy_collection_title: 'Información que Recopilamos',
  privacy_policy_personal_info: 'Información Personal',
  privacy_policy_personal_info_1: 'Nombre, dirección de correo electrónico, teléfono y dirección postal',
  privacy_policy_personal_info_2: 'Números de identificación fiscal (SSN, ITIN, EIN) e información empresarial',
  privacy_policy_personal_info_3: 'Información financiera para preparación de impuestos y servicios de formación de empresas',
  privacy_policy_personal_info_4: 'Estado migratorio, composición familiar e información de dependientes para fines fiscales',
  privacy_policy_usage_data: 'Datos de Uso',
  privacy_policy_usage_data_1: 'Dirección IP, tipo de navegador e información del dispositivo',
  privacy_policy_usage_data_2: 'Páginas visitadas, tiempo transcurrido y patrones de interacción',
  privacy_policy_usage_data_3: 'Fuentes de referencia y términos de búsqueda',
  privacy_policy_usage_data_4: 'Cookies y tecnologías de seguimiento similares',
  privacy_policy_cookies_title: 'Cookies y Tecnologías de Seguimiento',
  privacy_policy_cookies_description: 'Utilizamos cookies y tecnologías similares para mejorar tu experiencia, analizar el uso y proporcionar contenido personalizado. Puedes gestionar tus preferencias de cookies a través de nuestro banner de consentimiento.',
  privacy_policy_cookie_types: 'Tipos de Cookies que Utilizamos',
  privacy_policy_necessary_cookies: 'Esenciales para la funcionalidad y seguridad del sitio web',
  privacy_policy_analytics_cookies: 'Nos ayudan a entender el comportamiento del usuario y mejorar nuestros servicios',
  privacy_policy_marketing_cookies: 'Utilizadas para publicidad dirigida y campañas de marketing',
  privacy_policy_functional_cookies: 'Habilitan características mejoradas como chat en vivo y videos',
  privacy_policy_usage_title: 'Cómo Utilizamos tu Información',
  privacy_policy_usage_1: 'Proporcionar y mantener nuestros servicios de contabilidad, preparación de impuestos y consultoría empresarial',
  privacy_policy_usage_2: 'Procesar declaraciones de impuestos, solicitudes de ITIN y documentos de formación de empresas',
  privacy_policy_usage_3: 'Comunicarnos contigo sobre nuestros servicios, plazos y actualizaciones regulatorias',
  privacy_policy_usage_4: 'Mejorar nuestro sitio web y servicios basado en análisis de uso y comentarios de clientes',
  privacy_policy_usage_5: 'Cumplir con requisitos del IRS, FinCEN y otras obligaciones regulatorias',
  privacy_policy_usage_6: 'Proteger contra fraudes y garantizar la seguridad de la plataforma para datos financieros sensibles',
  privacy_policy_sharing_title: 'Intercambio y Divulgación de Información',
  privacy_policy_sharing_description: 'No vendemos, intercambiamos o alquilamos tu información personal. Solo podemos compartir información en las siguientes circunstancias:',
  privacy_policy_sharing_1: 'Con tu consentimiento explícito o bajo tu dirección',
  privacy_policy_sharing_2: 'Con proveedores de servicios confiables que asisten nuestras operaciones',
  privacy_policy_sharing_3: 'Para cumplir obligaciones legales u órdenes judiciales',
  privacy_policy_sharing_4: 'Para proteger nuestros derechos, propiedad o seguridad y la de nuestros usuarios',
  privacy_policy_security_title: 'Seguridad de Datos',
  privacy_policy_security_description: 'Implementamos medidas de seguridad estándar de la industria para proteger tu información, incluyendo cifrado, servidores seguros y auditorías regulares de seguridad. Sin embargo, ningún método de transmisión por internet es 100% seguro.',
  privacy_policy_rights_title: 'Tus Derechos de Privacidad',
  privacy_policy_rights_1: 'Acceder y revisar tu información personal',
  privacy_policy_rights_2: 'Solicitar corrección de datos inexactos o incompletos',
  privacy_policy_rights_3: 'Solicitar eliminación de tu información personal',
  privacy_policy_rights_4: 'Objetar o restringir ciertas actividades de procesamiento',
  privacy_policy_rights_5: 'Solicitar portabilidad de datos en formato estructurado',
  privacy_policy_rights_6: 'Retirar consentimiento para procesamiento opcional de datos',
  privacy_policy_transfers_title: 'Transferencias Internacionales de Datos',
  privacy_policy_transfers_description: 'Como servimos clientes internacionalmente, tu información puede ser transferida y procesada en países diferentes a tu residencia. Garantizamos que las salvaguardas apropiadas estén en su lugar para tales transferencias.',
  privacy_policy_retention_title: 'Retención de Datos',
  privacy_policy_retention_description: 'Retenemos tu información solo el tiempo necesario para proporcionar nuestros servicios, cumplir obligaciones legales o resolver disputas. Los documentos relacionados con impuestos pueden ser retenidos por períodos extendidos según lo requerido por ley.',
  privacy_policy_contact_title: 'Contáctanos',
  privacy_policy_contact_description: 'Si tienes preguntas sobre esta Política de Privacidad o deseas ejercer tus derechos de privacidad, contáctanos:',
  privacy_policy_updates_title: 'Actualizaciones de la Política',
  privacy_policy_updates_description: 'Podemos actualizar esta Política de Privacidad periódicamente. Te notificaremos sobre cambios significativos a través de nuestro sitio web o comunicación directa. Tu uso continuado de nuestros servicios constituye aceptación de la política actualizada.',
  contact_email: 'Correo electrónico',
  contact_address: 'Dirección',
  contact_phone: 'Teléfono',
  all_rights_reserved: 'Todos los derechos reservados.'
};
